// extracted by mini-css-extract-plugin
module.exports = {"html":"layout_html__EHXyd","body":"layout_body__oiEIT"};